import React, { useState } from 'react'

import { useHistory } from 'react-router-dom'
import axios, { AxiosError } from 'axios'

import Signup2Contractor from '../../../../../presentation/pages/contractors/amplify/signup2Contractors'

import { RoutesEnum } from '../../../../../presentation/enums'

const MakeSignup2Contractors = (): JSX.Element => {
  window.dataLayer.push({
    event: 'signupContractor2',
  })
  document.title = 'BuscarMédicos - Cadastro - Passo 2'
  // const { updateMe, formatPermissions } = useMe()
  const history = useHistory()
  const [errorMessage, setErrorMessage] = useState<string | null>('')
  const [selectedImage, setSelectedImage] = useState<File | any>(null)
  const [imageBase64, setImageBase64] = useState<string | null>(null)

  const handleImageSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0]

    if (!(file?.type === 'image/jpeg' || file?.type === 'image/png')) {
      setErrorMessage(
        'O arquivo enviado não é uma imagem válida. Tente enviar uma imagem no formato JPEG ou PNG.',
      )
      return
    }

    if (file) {
      setSelectedImage(file)

      const reader = new FileReader()
      reader.onloadend = () => {
        setImageBase64(reader.result as string)
      }
      reader.readAsDataURL(file)
    }
  }

  const uploadImage = async (file: File) => {
    const userEmail = localStorage.getItem('userEmail')

    if (!userEmail) {
      throw new Error('E-mail não encontrado no localStorage')
    }

    const formData = new FormData()
    formData.append('file', new File([file], file.name))

    formData.append('email', userEmail)

    formData.append('type', 'application/jpeg')

    const apiUrl = process.env.REACT_APP_API_URL

    const response = await axios.post(
      `${apiUrl}/public/register/contractor/upload-file`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )

    return response.data
  }

  const dataForm = [
    {
      items: [
        {
          name: 'button',
          component: 'Button',
          title: 'Prosseguir',
          submittingText: 'Carregando...',
          color: true,
        },
      ],
    },
  ]

  const onSubmit = async (): Promise<void> => {
    try {
      if (selectedImage) {
        await uploadImage(selectedImage)
      }
      history.push(RoutesEnum.SIGNUP3_CONTRACTOR)
    } catch (error) {
      if (error instanceof AxiosError && error.response?.status === 413) {
        setErrorMessage(
          'O arquivo enviado é muito grande. Tente enviar um arquivo menor.',
        )
      }
    }
  }

  return (
    <Signup2Contractor
      dataForm={dataForm}
      onSubmit={onSubmit}
      errorMessage={errorMessage}
      selectedImage={imageBase64}
      handleImageSelect={handleImageSelect}
    />
  )
}

export default MakeSignup2Contractors
